import React from "react";
import Vector from "../assets/imgs/dashboard/Vector.png";
import {
  Button,
  Card,
  CardBody,
  CardImg,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSingleMedia } from "../redux/actions/memoir.action";
import { Chrono } from "react-chrono";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { customAlert } from "../redux/actions/alertActions";
import {
  deleteMemoirMedia,
  deleteSingleMediaFile,
  editMemoirMedia,
} from "../redux/actions/memoir.action";
import { useDropzone } from "react-dropzone";
import CustomTimeline from "./CustomTimeline";
import CustomDatePicker from "./CustomDatePicker";
import moment from "moment";
import ArrowLeft from "../assets/imgs/new/arrow-left.png";
import ArrowRight from "../assets/imgs/new/arrow-right.png";
import { Link } from "react-router-dom";
const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};
function MemoirMedia({ memoir_id, isEditable }) {
  const [deleteModal, setDeleteModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [files, setFiles] = useState([]);
  const [mediaData, setMediaData] = useState("");
  const [searchMedia, setSearchMedia] = useState("");
  const [media_date, setMedia_date] = useState("");
  const [media_heading, setMedia_heading] = useState("");
  const [media_desc, setMedia_desc] = useState("");
  const [prevImages, setPrevImages] = useState([]);
  const [mediaId, setMediaId] = useState("");
  const [viewMedia, setViewMedia] = useState(false);
  const [activeView, setActiveView] = useState("card");
  const [activeMedia, setActiveMedia] = useState("");
  const [timelineYear, setTimelineYear] = useState([]);
  const [timelineData, setTimelineData] = useState([]);
  const [timelineMedia, setTimelineMedia] = useState();
  const [activeYear, setActiveYear] = useState("");
  const [activeMediaView, setActiveMediaView] = useState(false);
  const [alertModal, setAlertModal] = useState(false);

  const dispatch = useDispatch();
  const { singleMedia } = useSelector((state) => state.memoir);
  console.log(
    "🚀 ~ file: MemoirMedia.js ~ line 77 ~ MemoirMedia ~ singleMedia",
    singleMedia
  );
  const authUser = useSelector((state) => state.authUser);
  const { mediaLoading } = useSelector((state) => state.memoir);
  const { singleMemoir } = useSelector((state) => state.memoir);

  const getTimelineYears = () => {
    if (timelineYear) {
      timelineYear.sort((a, b) => Number(a.title) - Number(b.title));

      return timelineYear;
    }
    return [];
  };
  const scrollMedia = (shift) => {
    let el = document.getElementById("card-media");
    el.scrollLeft += shift;
  };
  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({
    accept: "audio/*,video/*,image/*",
    onDrop: (acceptedFiles) => {
      let tempFiles = acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      );
      let tempArr = files.concat(tempFiles);
      setFiles(tempArr);
      // setFiles([
      // 	Object.assign(acceptedFiles[0], {
      // 		preview: URL.createObjectURL(acceptedFiles[0]),
      // 	}),
      // ]);
    },
  });
  let images = files.map((file, index) => (
    // <Row key={file.name} className="position-absolute">
    <Col style={{ position: "relative" }}>
      <i
        className="fas fa-minus-circle"
        style={{
          color: "red",
          position: "absolute",
          top: "0%",
          right: "0%",
          cursor: "pointer",
        }}
        onClick={() => {
          files.splice(index, 1);
          setFiles([...files]);
        }}
      ></i>
      {file.type.split("/")[0] == "image" && (
        <img
          src={file.preview}
          style={{ width: "100px", height: "100px" }}
          alt="preview"
          className="mx-2 mt-2"
        ></img>
      )}

      {
        file.type.split("/")[0] == "video" && (
          <div className="memoir-default-cover"></div>
        )
        // <video
        // 	src={file.preview}
        // 	style={{ width: '100px', height: '100px' }}
        // 	alt='preview'
        // 	className='mx-2 mt-2'
        // ></video>
      }

      {file.type.split("/")[0] == "audio" && (
        <img
          src={
            "https://firebasestorage.googleapis.com/v0/b/memora-admin-platform.appspot.com/o/arafsd.png?alt=media&token=d6f72de3-793e-4af5-8e3c-c676d20c442a"
          }
          style={{ width: "100px", height: "100px" }}
          alt="preview"
          className="mx-2 mt-2"
        ></img>
      )}
      {/* <img
						src={file.preview}
						style={{ width: '100px', height: '100px' }}
						alt='preview'
						className='mx-2 mt-2'
					></img> */}

      {/* <i onClick={remove(file)} style={{position:"absolute",top:"0%",left:"70%",cursor:"pointer"}} className='fas fa-times-circle' /> */}
    </Col>
    // </Row>
  ));
  const deleteToggle = () => {
    setDeleteModal(!deleteModal);
  };
  const editToggle = () => {
    setEditModal(!editModal);
  };
  const viewMediaToggle = () => {
    setViewMedia(!viewMedia);
  };
  const getTimelineData = () => {
    const res = [];
    let med_data = [];
    singleMedia.length > 0 &&
      singleMedia.map((media, index) => {
        let newRes = media.media_date.split("-")[0];
        res.push({ title: newRes });
      });
    med_data =
      singleMedia.length > 0 &&
      singleMedia.filter((media) => media.media_date.includes(activeYear));
    const key = "title";
    setTimelineYear([
      ...new Map(res.map((item) => [item[key], item])).values(),
    ]);
    if (res.length > 0 && !activeYear) {
      let firstyear = res[0].title;
      setActiveYear(firstyear);
    }
    setTimelineData(med_data);
  };
  const checkContent = (data) => {
    setActiveYear(data.title);
  };
  useEffect(() => {
    dispatch(getSingleMedia(memoir_id));
  }, []);
  useEffect(() => {
    getTimelineData();
  }, [singleMedia, activeYear]);
  useEffect(() => {
    console.log("testing");
    if (singleMemoir && singleMemoir.isMemoirPublic == false) {
      if (authUser?.id) {
        if (singleMemoir?.user_id != authUser?.id) {
          setAlertModal(true);
        }
      } else {
      }
    } else {
      setAlertModal(false);
    }
  }, [singleMemoir]);
  const checkFileType = (fileName) => {
    switch (fileName.split("/")[0]) {
      case "image":
        return "image";
      case "video":
        return "video";
      case "audio":
        return "audio";
      default:
        return "N/A";
    }
  };
  return (
    <>
      {alertModal ? (
        <div>
          <>
            <Row className="mt-2">
              <Col md="12" className="text-center p-5 private-timeline-box">
                <div className="mb-5 mt-2">
                  <img src={Vector} alt="eye-image" />
                </div>

                <span className="private-timeline-box__heading">
                  This Timeline is private
                </span>
                <br />
                <br />
                {authUser?.id ? (
                  ""
                ) : (
                  <span>
                    <Link to="/dashboard/register">
                      <span className="private-timeline-box__link-text">
                        Login
                      </span>
                    </Link>{" "}
                    or{" "}
                    <Link to="/dashboard/register">
                      {" "}
                      <span className="private-timeline-box__link-text">
                        Sign up
                      </span>
                    </Link>{" "}
                    to view or contribute
                  </span>
                )}
              </Col>
            </Row>

            {/* <Row className="mt-3 justify-content-center">
                <Col md="5">
                  <Link to="/dashboard/register">
                    <Button className="btn-outline landing-btn" width="100%">
                      Login
                    </Button>
                  </Link>
                </Col>
                <Col md="5">
                  <Link to="/dashboard/register">
                    <Button className=" btn-outline landing-btn">
                      SIGN UP
                    </Button>
                  </Link>
                </Col>
              </Row> */}
          </>
        </div>
      ) : (
        <div>
          {singleMedia.length > 0 ? (
            <>
              <div className="d-flex my-4">
                <InputGroup className="ml-auto w-auto">
                  <InputGroupAddon addonType="prepend">
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{
                        backgroundColor: "#E5E5E5",
                        width: 50,
                        border: "1px solid var(--fieldBorderColor)",
                        borderTopLeftRadius: ".25rem",
                        borderBottomLeftRadius: ".25rem",
                      }}
                    >
                      <i className="fa fa-search"></i>
                    </div>
                  </InputGroupAddon>
                  <Input
                    placeholder="Search"
                    value={searchMedia}
                    onChange={(e) => setSearchMedia(e.target.value)}
                  ></Input>
                </InputGroup>
              </div>
              <Container className="my-4">
                <div className="text-center">
                  <Button
                    className="btn-outline dashboard-btn"
                    onClick={() => {
                      setActiveView("card");
                      setActiveMediaView(false);
                    }}
                  >
                    Card View
                  </Button>
                  <Button
                    className="btn-outline ml-3 dashboard-btn"
                    onClick={() => {
                      setActiveView("timeline");
                      setActiveMediaView(false);
                    }}
                  >
                    Timeline View
                  </Button>
                </div>
                <div className="d-flex justify-content-center position-relative mt-5">
                  <h2 className="text-center">
                    {activeView == "card" ? "Card" : "Timeline"}
                  </h2>
                </div>
              </Container>
              <div className={`${activeView != "card" && "d-none"}`}>
                <Container fluid={isEditable}>
                  <div
                    // id="card-media"
                    className="w-100"
                    style={{
                      overflowY: "auto",
                      scrollBehavior: "smooth",
                    }}
                  >
                    <Row className="mt-4  mb-5">
                      {singleMedia &&
                        singleMedia
                          .filter((med) => {
                            if (searchMedia == "") {
                              return med;
                            } else if (
                              (med.media_heading != "" &&
                                med.media_heading
                                  .toLowerCase()
                                  .includes(searchMedia.toLowerCase())) ||
                              (med.media_desc != "" &&
                                med.media_desc
                                  .toLowerCase()
                                  .includes(searchMedia.toLowerCase()))
                            ) {
                              return med;
                            }
                          })
                          .map((media, index) => {
                            return (
                              <Col md="4" key={index} className="mb-4">
                                <Card className="pointer h-100">
                                  {media.media_files &&
                                    media.media_files.length > 0 &&
                                    media.media_files[0] &&
                                    media.media_files[0].type &&
                                    checkFileType(media.media_files[0].type) ==
                                      "image" && (
                                      <CardImg
                                        src={
                                          media.media_files &&
                                          media.media_files.length > 0 &&
                                          media.media_files[0].url
                                        }
                                        onClick={() => {
                                          setTimelineMedia(media);
                                          viewMediaToggle();
                                        }}
                                        className="lc_media_img"
                                      />
                                    )}

                                  {media.media_files &&
                                    media.media_files.length > 0 &&
                                    media.media_files[0] &&
                                    media.media_files[0].type &&
                                    checkFileType(media.media_files[0].type) ==
                                      "video" && (
                                      <div
                                        className=" lc_media_default_img"
                                        onClick={() => {
                                          setTimelineMedia(media);
                                          viewMediaToggle();
                                        }}
                                      ></div>
                                    )}

                                  {media.media_files &&
                                    media.media_files.length > 0 &&
                                    media.media_files[0] &&
                                    media.media_files[0].type &&
                                    checkFileType(media.media_files[0].type) ==
                                      "audio" && (
                                      <div
                                        className=" lc_media_default_img"
                                        onClick={() => {
                                          setTimelineMedia(media);
                                          viewMediaToggle();
                                        }}
                                      ></div>
                                    )}
                                  <CardBody className="px-1 pb-0 memoir__media">
                                    <h4 className="memoir__media__heading">
                                      {media.media_heading}
                                    </h4>
                                    <h6 className="memoir__media__desc">
                                      {media.media_desc}
                                    </h6>

                                    <div className="my-3 d-flex align-items-center">
                                      <h6 className="memoir__media__date">
                                        {media.media_date &&
                                          moment(media.media_date).format(
                                            "DD-MM-YYYY"
                                          )}
                                      </h6>
                                      <small
                                        className={`ml-auto mr-3 text-muted ${
                                          !isEditable && "d-none"
                                        }`}
                                      >
                                        <i
                                          className="fa fa-pencil text-info pointer"
                                          onClick={() => {
                                            setMedia_heading(
                                              media.media_heading
                                            );
                                            setPrevImages(media.media_files);
                                            setMedia_desc(media.media_desc);
                                            setMedia_date(media.media_date);
                                            setMediaId(media.id);
                                            setMediaData(media);
                                            editToggle();
                                          }}
                                        ></i>
                                      </small>
                                      <small
                                        className={` mr-3 text-muted ${
                                          !isEditable && "d-none"
                                        }`}
                                      >
                                        <i
                                          className="fa fa-trash pointer text-danger"
                                          onClick={() => {
                                            deleteToggle();
                                            setMediaData(media);
                                          }}
                                        ></i>
                                      </small>
                                    </div>
                                  </CardBody>
                                </Card>
                              </Col>
                            );
                          })}
                    </Row>
                  </div>
                  {/* {singleMedia && singleMedia.length > 3 && (
                <div className="text-right">
                  <img
                    src={ArrowLeft}
                    alt="left"
                    className="pointer"
                    onClick={() => scrollMedia(-340)}
                  />
                  <span className="ml-3 mr-1">{1}</span>-
                  <span className="ml-1 mr-3">{singleMedia.length}</span>
                  <img
                    src={ArrowRight}
                    alt="right"
                    className="pointer"
                    onClick={() => scrollMedia(340)}
                  />
                </div>
              )} */}
                </Container>
              </div>

              <div className={`${!activeMediaView && "d-none"}`}>
                <Container fluid={isEditable}>
                  <div className="d-flex align-items-center justify-content-center">
                    <i className="fa fa-long-arrow-left"></i>
                    <span className="px-2">
                      1-{activeMedia && activeMedia.length}
                    </span>
                    <i className="fa fa-long-arrow-right"></i>
                  </div>
                  <div className="w-100" style={{ overflowY: "auto" }}>
                    <Row noGutters className="mt-4 flex-nowrap">
                      {activeMedia.length > 0 &&
                        activeMedia.map((media, idx) => {
                          return (
                            <Col md="4" key={idx}>
                              <div className="px-4 img-box-timeline active h-100">
                                {checkFileType(media.type) == "image" && (
                                  <img
                                    src={media.url}
                                    className="lc_media_img"
                                  />
                                )}

                                {checkFileType(media.type) == "video" && (
                                  <video
                                    src={media.url}
                                    className="lc_media_img"
                                    controls
                                  />
                                )}

                                {checkFileType(media.type) == "audio" && (
                                  <audio
                                    src={media.url}
                                    className="lc_media_img"
                                    controls
                                  />
                                )}

                                <div className="active-cont"></div>
                              </div>
                            </Col>
                          );
                        })}
                    </Row>
                  </div>
                </Container>
              </div>

              <div className={`${activeView != "timeline" && "d-none"}`}>
                <Container fluid={isEditable}>
                  <div style={{ width: "100%" }}>
                    {timelineYear.length > 0 && (
                      // <Chrono
                      // 	theme={{ primary: '#E5E5E5' }}
                      // 	items={timelineYear}
                      // 	hideControls={true}
                      // 	cardHeight={0}
                      // 	cardWidth={0}
                      // 	allowDynamicUpdate={true}
                      // 	onItemSelected={checkContent}
                      // 	scrollable
                      // />

                      <CustomTimeline
                        timelineYear={getTimelineYears()}
                        selectedYear={activeYear}
                        onChange={checkContent}
                      />
                    )}
                  </div>
                  <div className="d-flex justify-content-center">
                    <h2 className="font-weight-bold">
                      Milestones of the {activeYear}
                    </h2>
                  </div>
                  <div
                    id="card-media"
                    className="w-100"
                    style={{
                      overflowY: "auto",
                      scrollBehavior: "smooth",
                    }}
                  >
                    <Row className="mt-5 mb-5 flex-nowrap">
                      {timelineData.length > 0 &&
                        timelineData
                          .filter((med) => {
                            if (searchMedia == "") {
                              return med;
                            } else if (
                              (med.media_heading != "" &&
                                med.media_heading
                                  .toLowerCase()
                                  .includes(searchMedia.toLowerCase())) ||
                              (med.media_desc != "" &&
                                med.media_desc
                                  .toLowerCase()
                                  .includes(searchMedia.toLowerCase()))
                            ) {
                              return med;
                            }
                          })
                          .map((data, index) => {
                            return (
                              <Col md="4" key={index}>
                                <Card className="pointer h-100">
                                  {data.media_files &&
                                    data.media_files.length > 0 &&
                                    data.media_files[0] &&
                                    data.media_files[0].type &&
                                    checkFileType(data.media_files[0].type) ==
                                      "image" && (
                                      <CardImg
                                        src={
                                          data.media_files &&
                                          data.media_files.length > 0 &&
                                          data.media_files[0].url
                                        }
                                        onClick={() => {
                                          setTimelineMedia(data);
                                          viewMediaToggle();
                                        }}
                                        className="lc_media_img"
                                      />
                                    )}

                                  {data.media_files &&
                                    data.media_files.length > 0 &&
                                    data.media_files[0] &&
                                    data.media_files[0].type &&
                                    checkFileType(data.media_files[0].type) ==
                                      "video" && (
                                      <div
                                        className="lc_media_default_img"
                                        onClick={() => {
                                          setTimelineMedia(data);
                                          viewMediaToggle();
                                        }}
                                      ></div>
                                    )}

                                  {data.media_files &&
                                    data.media_files.length > 0 &&
                                    data.media_files[0] &&
                                    data.media_files[0].type &&
                                    checkFileType(data.media_files[0].type) ==
                                      "audio" && (
                                      <div
                                        className="lc_media_default_img"
                                        onClick={() => {
                                          setTimelineMedia(data);
                                          viewMediaToggle();
                                        }}
                                      ></div>
                                    )}

                                  <CardBody
                                    className="px-1 pb-0 memoir__media"
                                    // style={{
                                    // 	background: `linear-gradient(180deg, rgba(219, 195, 166, 0) 0%, #DBC3A6 65.94%)`,
                                    // }}
                                  >
                                    <h4 className="memoir__media__heading">
                                      {data.media_heading}
                                    </h4>
                                    <h6 className="memoir__media__desc">
                                      {data.media_desc}
                                    </h6>

                                    <div className=" my-3 d-flex align-items-center">
                                      <h6 className="memoir__media__date ">
                                        {data.media_date &&
                                          moment(data.media_date).format(
                                            "DD-MM-YYYY"
                                          )}
                                      </h6>
                                      <small
                                        className={`ml-auto mr-3 text-muted ${
                                          !isEditable && "d-none"
                                        }`}
                                      >
                                        <i
                                          className="fa fa-pencil text-info pointer"
                                          onClick={() => {
                                            setMedia_heading(
                                              data.media_heading
                                            );
                                            setPrevImages(data.media_files);
                                            setMedia_desc(data.media_desc);
                                            setMedia_date(data.media_date);
                                            setMediaId(data.id);
                                            setMediaData(data);
                                            editToggle();
                                          }}
                                        ></i>
                                      </small>
                                      <small
                                        className={` mr-3 text-muted ${
                                          !isEditable && "d-none"
                                        }`}
                                      >
                                        <i
                                          className="fa fa-trash pointer text-danger"
                                          onClick={() => {
                                            deleteToggle();
                                            setMediaData(data);
                                          }}
                                        ></i>
                                      </small>
                                    </div>
                                  </CardBody>
                                </Card>
                              </Col>
                            );
                          })}
                    </Row>
                  </div>
                  {timelineData && timelineData.length > 3 && (
                    <div className="text-right">
                      <img
                        src={ArrowLeft}
                        alt="left"
                        className="pointer"
                        onClick={() => scrollMedia(-340)}
                      />
                      <span className="ml-3 mr-1">{1}</span>-
                      <span className="ml-1 mr-3">{timelineData.length}</span>
                      <img
                        src={ArrowRight}
                        alt="right"
                        className="pointer"
                        onClick={() => scrollMedia(340)}
                      />
                    </div>
                  )}
                </Container>
              </div>
            </>
          ) : (
            <div className="text-center my-5">
              <strong>No Media Found</strong>
            </div>
          )}
          <Modal centered isOpen={viewMedia} toggle={viewMediaToggle} size="lg">
            <ModalHeader
              className="border-0 memoir__media bg-white p-0 pt-2 pr-2"
              toggle={viewMediaToggle}
            ></ModalHeader>
            <ModalBody className="bg-white rounded pt-0 memoir__media">
              <h5 className="memoir__media__heading mb-0 text-center mt-3">
                {timelineMedia && timelineMedia.media_heading}
              </h5>

              <div className="d-flex mt-5">
                {/* <div className='m-0 p-0 imgItem'>Image</div> */}
                <div className="infoItem">
                  {/* <p className='m-0 p-0 infoName'>
								<strong>David Wood’s Memora</strong>
							</p> */}

                  <p className="m-0 p-0">
                    <strong>
                      created At {timelineMedia && timelineMedia.media_date}
                    </strong>
                  </p>
                </div>
              </div>
              <Row>
                {timelineMedia &&
                  timelineMedia.media_files &&
                  timelineMedia.media_files.map((media, idx) => {
                    return (
                      <Col xs="12" md="12" key={idx}>
                        {checkFileType(media.type) == "image" && (
                          <img src={media.url} className="lc_media_img2 mt-5" />
                        )}
                        {checkFileType(media.type) == "video" && (
                          <video
                            src={media.url}
                            className="lc_media_img"
                            controls
                          />
                        )}
                        {checkFileType(media.type) == "audio" && (
                          <audio
                            src={media.url}
                            className="lc_media_img"
                            controls
                          />
                        )}
                      </Col>
                    );
                  })}
              </Row>
              <div className="memoir__media">
                <p className="memoir__media__desc mb-0 mt-5 count">
                  {timelineMedia && timelineMedia.media_desc}
                </p>
              </div>
            </ModalBody>
          </Modal>
          {/* Delete Modal */}
          <Modal isOpen={deleteModal} centered toggle={deleteToggle}>
            <ModalBody>
              <div className="text-center">
                <i
                  className="far fa-times-circle text-danger"
                  style={{ fontSize: 70 }}
                ></i>
                <br />
                <br />
                <span className="mt-5" style={{ fontSize: 30 }}>
                  Are you sure?
                </span>
                <br />
                <br />
                <span className="mt-5" style={{ fontSize: 16 }}>
                  Do you really want to remove this Memoir? This process cannot
                  be undone.
                </span>
                <br />
                <br />
                <br />
                <Button color="secondary" onClick={deleteToggle}>
                  Cancel
                </Button>{" "}
                <Button
                  color="danger"
                  onClick={async (e) => {
                    e.preventDefault();
                    if (memoir_id != "" && mediaData && mediaData.id) {
                      await dispatch(
                        deleteMemoirMedia(memoir_id, mediaData.id)
                      );
                      deleteToggle();
                    } else {
                      dispatch(
                        customAlert(
                          true,
                          "Please Select Media you want to delete!"
                        )
                      );
                      setTimeout(() => {
                        dispatch(customAlert(false, ""));
                      }, 1500);
                      // toast.warning('Please Select Media you want to delete!');
                    }
                  }}
                  disabled={mediaLoading}
                >
                  {mediaLoading ? <Spinner size="sm" /> : "Delete"}
                </Button>
              </div>
            </ModalBody>
          </Modal>

          {/* Edit Modal */}
          <Modal
            isOpen={editModal}
            size="lg"
            centered
            className="custom-modal"
            toggle={(e) => editToggle}
          >
            <ModalBody>
              <Form
                onSubmit={async (e) => {
                  e.preventDefault();
                  if (files.length > 0) {
                    // if (prevImages && prevImages.length > 0) {
                    // 	dispatch(
                    // 		deleteSingleMediaFile(
                    // 			memoir_id,
                    // 			mediaId,
                    // 			prevImages[0]
                    // 		)
                    // 	);
                    // }
                    let obj = {
                      media_heading: media_heading,
                      media_date: media_date,
                      media_desc: media_desc,
                    };
                    await dispatch(
                      editMemoirMedia(
                        memoir_id,
                        mediaId,
                        obj,
                        files,
                        authUser?.id
                      )
                    );
                    editToggle();
                    setFiles([]);
                    setMedia_desc("");
                    setMedia_heading("");
                    setMedia_date("");
                  } else {
                    let obj = {
                      media_heading: media_heading,
                      media_date: media_date,
                      media_desc: media_desc,
                    };
                    await dispatch(
                      editMemoirMedia(
                        memoir_id,
                        mediaId,
                        obj,
                        files,
                        authUser?.id
                      )
                    );
                    editToggle();
                    setFiles([]);
                    setMedia_desc("");
                    setMedia_heading("");
                    setMedia_date("");
                  }

                  // eleteSingleMediaFile(
                  // 	memoir_id,
                  // 	mediaId,
                  // 	media
                  // )
                }}
              >
                <div>
                  <div className="d-flex">
                    <div className="ml-auto pointer">
                      <i
                        className="fa fa-times"
                        onClick={(e) => editToggle()}
                      ></i>
                    </div>
                  </div>
                  <h5 className="font-weight-bold text-center">Update Media</h5>
                  <div className="row mt-5">
                    <div className="col">
                      <label className="m-0">Start date</label>
                      <div className="row">
                        <div className="col-12">
                          <CustomDatePicker
                            id={"test"}
                            value={media_date}
                            max={moment().toISOString().substring(0, 10)}
                            onChange={(e) => setMedia_date(e.target.value)}
                            isRequired={false}
                          />
                          {/* <input
												value={media_date}
												required
												onChange={e =>
													setMedia_date(
														e.target.value
													)
												}
												type='date'
												className='form-control'
												placeholder='yyyy'
											/> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col">
                      <label className="m-0">Title</label>
                      <div className="row">
                        <div className="col-12">
                          <input
                            value={media_heading}
                            onChange={(e) => setMedia_heading(e.target.value)}
                            type="text"
                            className="form-control"
                            placeholder="Title"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="position-relative">
                    <div {...getRootProps()} className="mt-5">
                      <input {...getInputProps()} />
                      <div
                        className="jumbotron ml-0 "
                        style={{
                          paddingLeft: 10,
                          marginBottom: 10,
                          borderStyle: "dashed",
                          borderRadius: 5,
                          borderWidth: 1,
                          borderColor: "black",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "center",
                          left: "50%",
                        }}
                      >
                        <p className="plus_icon">+</p>

                        <p
                          style={{ cursor: "default" }}
                          className="text-black text-lg"
                        >
                          <span className="sub_text">Add Photo/Videos</span> or
                          drop file here
                        </p>
                      </div>
                    </div>
                    <Row
                      className="position-absolute"
                      style={{ top: "10px", left: "10px" }}
                    >
                      {images}
                    </Row>
                  </div>
                  <Label className="mt-3">Previous Images</Label>
                  <Row>
                    {prevImages &&
                      prevImages.length > 0 &&
                      prevImages.map((media, index) => {
                        return (
                          <Col xs="3">
                            <div
                              style={{
                                position: "relative",
                              }}
                            >
                              <i
                                className="fas fa-minus-circle"
                                style={{
                                  color: "red",
                                  position: "absolute",
                                  top: "0%",
                                  left: "0%",
                                  cursor: "pointer",
                                }}
                                onClick={async (e) => {
                                  e.preventDefault();
                                  await dispatch(
                                    deleteSingleMediaFile(
                                      memoir_id,
                                      mediaId,
                                      media
                                    )
                                  );
                                  prevImages.splice(index, 1);
                                  setPrevImages([...prevImages]);
                                }}
                              ></i>

                              {checkFileType(media.type) == "image" && (
                                <img
                                  src={media.url}
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                  }}
                                  alt="preview"
                                  className="mx-2 mt-2"
                                ></img>
                              )}

                              {checkFileType(media.type) == "video" && (
                                <video
                                  src={media.url}
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                  }}
                                  alt="preview"
                                  className="mx-2 mt-2"
                                ></video>
                              )}

                              {checkFileType(media.type) == "audio" && (
                                <img
                                  src={
                                    "https://firebasestorage.googleapis.com/v0/b/memora-admin-platform.appspot.com/o/arafsd.png?alt=media&token=d6f72de3-793e-4af5-8e3c-c676d20c442a"
                                  }
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                  }}
                                  alt="preview"
                                  className="mx-2 mt-2"
                                ></img>
                              )}

                              {/* <i onClick={remove(file)} style={{position:"absolute",top:"0%",left:"70%",cursor:"pointer"}} className='fas fa-times-circle' /> */}
                            </div>
                          </Col>
                        );
                      })}
                  </Row>

                  <label className="mt-3">Add a description</label>
                  <textarea
                    rows={5}
                    value={media_desc}
                    onChange={(e) => setMedia_desc(e.target.value)}
                    className="form-control"
                  />

                  <div className="d-flex mt-4 justify-content-end">
                    <button
                      className="btn btn-outline f14 mr-3 dashboard-btn "
                      type="submit"
                      disabled={mediaLoading}
                    >
                      {mediaLoading ? <Spinner size="sm" /> : "Save"}
                    </button>
                    <button
                      className="btn btn-outline f14 dashboard-btn"
                      onClick={(e) => {
                        e.preventDefault();
                        editToggle();
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      )}
    </>
  );
}

export default MemoirMedia;
